import React, { Component } from "react"
import { Link } from "react-router-dom";
import NewFooter from "../footer/newfooter";
import NewHeader from "../header/newheader";
import home from '../assets/Home/home.png'
import crumbarrow from '../assets/Home/right.png'
import togglearrow from '../assets/Home/togglearrow.png'
import "./centers.css"
import pr from "../assets/pr.jpg"
import pageleft from '../assets/Home/pageleft.png'
import pagenoleft from '../assets/Home/pagenoleft.png'
import pagenoright from '../assets/Home/pagenoright.png'
import pageright from '../assets/Home/pageright.png'
import { BASE } from "../api/api";
import Axios from "axios";
import HtmlParser from "react-html-parser";
import { List } from "react-content-loader";

class ResearchCenter extends Component {
    constructor() {
        super()
        this.state = {
            tab: "members",
            offsetpub: 0,
            offsetevent: 0,
            pubnext: true,
            pubincluded: []
        }
    }
    componentDidMount() {
        let nid = new URLSearchParams(this.props.location.search).get("nid")
        this.apicall(nid)
    }
    apicall(id) {
        Axios.get(`${BASE}jsonapi/taxonomy_term/research_center?include=field_members,field_members.field_member,field_members.field_member.field_image&filter[drupal_internal__tid]=${id}`)
            .then(data => {
                console.log("center details", data.data)
                if (data.data.data.length) {
                    this.setState({
                        details: data.data.data[0],
                        title: data.data.data[0].attributes.name,
                        included: data.data.included
                    })
                    this.getPubs(id)
                    this.getEvents(id)
                    this.getFaculty()
                }
                else
                    this.props.history.push("/404")
            })
            .catch(err => {
                console.log("error on center details get", err)
            })
    }
    getPubs(id) {
        Axios.get(`${BASE}jsonapi/node/submit_for_work?include=field_research__cluster,field_select_work_to_submit,field_author&filter[field_cis_center_publication.drupal_internal__tid]=${id}&page[offset]=${this.state.offsetpub}&page[limit]=10&sort=-field_year`)
            .then(pubs => {
                console.log("pubs in centers", pubs.data.data)
                this.setState({
                    pubs: pubs.data.data,
                    pubincluded: pubs.data.included,
                    pubscount: pubs.data.meta ? pubs.data.meta.count : ""
                })
                if (pubs.data.links.next) {
                    this.setState({
                        pubnext: true
                    })
                }
                else
                    this.setState({
                        pubnext: false
                    })
            })
            .catch(err => {
                console.log("error on pubs in centers", err)
            })
    }
    getEvents(id) {
        Axios.get(`${BASE}jsonapi/node/events?include=field_event_type&filter[field_cis_center_event.drupal_internal__tid]=${id}&page[offset]=${this.state.offsetevent}&page[limit]=10&sort=-field_date`)
            .then(events => {
                console.log("events in centers", events.data.data)
                this.setState({
                    events: events.data.data,
                    eventInclude: events.data.included,
                    eventcount: events.data.meta ? events.data.meta.count : ""
                })
                if (events.data.links.next) {
                    this.setState({
                        eventnext: true
                    })
                }
                else
                    this.setState({
                        eventnext: false
                    })
            })
            .catch(err => {
                console.log("error on pubs in centers", err)
            })
    }
    getFaculty() {
        Axios.get(`${BASE}jsonapi/node/faculty?include=field_author_faculty`)
            .then(item => {
                this.setState({
                    faculty: item.data.data
                })
            })
            .catch(err => {
                console.log("faculty not found", err)
            })
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.pubscount !== this.state.pubscount || prevState.eventcount !== this.state.eventcount) {
            if (this.state.events && this.state.pubs) {
                if (!this.state.pubs.length && !this.state.events.length)
                    this.setState({
                        tab: "members"
                    })
                else if (!this.state.pubs.length && this.state.events.length)
                    this.setState({
                        tab: "events"
                    })
                else if (this.state.pubs.length && !this.state.events.length)
                    this.setState({
                        tab: "pubs"
                    })
                else if (this.state.pubs.length && this.state.events.length)
                    this.setState({
                        tab: "pubs"
                    })
            }
        }
        if (prevState.offsetpub !== this.state.offsetpub) {
            let nid = new URLSearchParams(this.props.location.search).get("nid")
            this.getPubs(nid)
        }
        if (prevState.offsetevent !== this.state.offsetevent) {
            let nid = new URLSearchParams(this.props.location.search).get("nid")
            this.getEvents(nid)
        }
    }

    render() {
        return (
            <div>
                <NewHeader />
                <div className="title-banner">
                    <h1 className="heading-one bold white-text">Research Centers</h1>
                </div>
                <div className="container">
                    <div className='top-contents'>
                        <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /><img className='rightarrow' src={crumbarrow} /><Link to='/research/centers' className='gray-text'>Research Centers</Link></Link><img className='rightarrow' src={crumbarrow} />{this.state.title ? this.state.title : ""}</div>
                    </div>
                    <div className="heading-three bold blue-text">
                        {this.state.details ? this.state.details.attributes ? this.state.details.attributes.name ? this.state.details.attributes.name : "" : '' : ""}
                    </div>
                    <p className="body-two center-description gray-text text-justify">
                        {this.state.details ? this.state.details.attributes ? this.state.details.attributes.field_body ? HtmlParser(this.state.details.attributes.field_body.value) : "" : '' : ""}
                    </p>
                    {this.state.details ? <div className="rows centers-details">
                        <div className="toggle-bar-one" style={{ marginTop: this.state.tab === "members" ? "60px" : "20px" }}>
                            <button style={{ display: this.state.pubs ? this.state.pubs.length ? "" : "none" : "none" }} onClick={() => this.setState({ tab: "pubs" })} className={this.state.tab === "pubs" ? 'blue-text body-two' : "gray-text body-two"}>Publications {this.state.tab === "pubs" ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                            <button style={{ display: this.state.events ? this.state.events.length ? "" : "none" : "none" }} onClick={() => this.setState({ tab: "events" })} className={this.state.tab === "events" ? 'blue-text body-two' : "gray-text body-two"}>Events {this.state.tab === "events" ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                            <button style={{ display: this.state.details.relationships.field_members.data ? this.state.details.relationships.field_members.data.length ? "" : "none" : "none" }} onClick={() => this.setState({ tab: "members" })} className={this.state.tab === "members" ? 'blue-text body-two' : "gray-text body-two"}>Members {this.state.tab === "members" ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                        </div>
                        <div className="centers-details-table">
                            {
                                this.state.tab === "members" ?
                                    <div className="cluster_profiles">
                                        {this.state.details.relationships.field_members.data ? this.state.details.relationships.field_members.data.length ?
                                            this.state.details.relationships.field_members.data.map((item, index) => {
                                                let data = this.state.included.filter(x => x.id === item.id)
                                                let nameData = this.state.included.filter(x => x.id === item.id)[0].relationships.field_member.data ? this.state.included.filter(x => x.id === item.id)[0].relationships.field_member.data.id : ""
                                                let names = nameData ? this.state.included.filter(x => x.id == nameData) : null
                                                let imageid = names ? names[0].relationships.field_image.data ? names[0].relationships.field_image.data.id : "" : ''
                                                let image = imageid ? this.state.included.filter(x => x.id == imageid) : ""
                                                console.log("name", image)
                                                return (
                                                    <div style={{ width: 22.75 + "%", marginRight: (index + 1) % 4 ? "3%" : "0%", marginBottom: 8 + "rem" }}>
                                                        <div className='image-container'>
                                                            <img className='clusterMember_pic' src={image ? image[0].attributes.uri ? BASE + image[0].attributes.uri.url : "" : ''} />
                                                        </div>
                                                        <Link to={`/faculty/${names[0].attributes.title.replace(/ /g, "-")}?nid=${names[0].attributes.drupal_internal__nid}`} className='body-two bold main-blue-text'>{names ? names[0].attributes.title ? names[0].attributes.title : "" : ''}</Link>
                                                        <p className='body-two gray-text'>{data ? data[0].attributes.field_designation ? data[0].attributes.field_designation : '' : ""}</p>
                                                    </div>
                                                )
                                            }) : "" : ""}
                                    </div> : ""
                            }
                            {
                                this.state.tab === "pubs" ?
                                    <div className="centers-pubs rows">
                                        <table className='newTable'>
                                            <tr className='projectStatus-head'>
                                                <th><p>Title</p></th>
                                                <th className='min-wids'><p>Author (s)</p></th>
                                                <th className='min-wids'><p> Type of Publication</p></th>
                                                <th className='min-wids'><p> Year</p></th>
                                            </tr>
                                            {this.state.pubs ? this.state.pubs.map((item, index) => {
                                                if (item.attributes)
                                                    return (
                                                        <tr className='projectDetails-row'>
                                                            <td className='title'><Link to={`/cis_publication/${item.attributes.title.replace(/\W+(?!$)/g, '-')}/${item.attributes.drupal_internal__nid}`}>{item.attributes.title}</Link></td>
                                                            <td className='min-wids' style={{ textAlign: "center" }}>{item.relationships.field_author.data.map(author => {
                                                                let faculty = this.state.faculty ? this.state.faculty.filter(x => {
                                                                    let id = x.relationships.field_author_faculty.data.filter(y => {
                                                                        if (y.id == author.id)
                                                                            return y.id
                                                                    })
                                                                    if (id.length)
                                                                        return id[0].id
                                                                }) : ""
                                                                console.log("faculty in publication", faculty)
                                                                return <p style={{ textAlign: "center" }}>{faculty.length ? <Link to={faculty.length ? `/faculty/${faculty[0].attributes.title.replace(/\W+(?!$)/g, '-')}?nid=${faculty[0].attributes.drupal_internal__nid}` : ``}>{this.state.pubincluded.filter(x => x.id == author.id)[0].attributes.title}</Link> : this.state.pubincluded.filter(x => x.id == author.id)[0].attributes.title}</p>
                                                            })}</td>
                                                            <td className='min-wids' style={{ textAlign: "center" }}>{this.state.pubincluded.filter(x => x.id === item.relationships.field_select_work_to_submit.data.id)[0].attributes.name}</td>
                                                            <td className='min-wids' style={{ textAlign: "center" }}>{item.attributes.field_year ? item.attributes.field_year : ""}</td>
                                                        </tr>
                                                    )
                                            }) : "No Publications found"}
                                        </table>
                                    </div>
                                    : ""
                            }
                            {this.state.tab === "events" ?
                                <div className="centers-events">
                                    <table className='newTable'>
                                        <tr>
                                            <th className='tableHead_1'><p>Title</p></th>
                                            <th className='tableHead_2 min-wids'><p>Type</p></th>
                                            <th className='tableHead_3 min-wids'><p>Theme/Speaker</p></th>
                                            <th className='tableHead_3 min-wids'><p>Year</p></th>
                                        </tr>
                                        {this.state.events ? this.state.events.map((data) => {
                                            if (data.attributes) {
                                                let date = new Date(data.attributes.field_date)
                                                let year = date.getFullYear()
                                                let type = data.relationships.field_event_type.data ? this.state.eventInclude.filter(x => x.id === data.relationships.field_event_type.data.id)[0].attributes.name : ""

                                                return (
                                                    <tr>
                                                        <td className=""><Link className="" to={{ pathname: '/event_desc/' + `${data.attributes.title.replace(/\W+(?!$)/g, '-')}/${data.attributes.drupal_internal__nid}` }}>{data.attributes.title ? data.attributes.title : ""}</Link></td>
                                                        <td className="min-wids">{type ? type : ""}</td>
                                                        <td className="">{data.attributes.field_theme_speaker ? data.attributes.field_theme_speaker : ""}</td>
                                                        <td className="min-wids">{year ? year : ""}</td>
                                                    </tr>
                                                )
                                            }
                                        }) : "No Events found"}
                                    </table>

                                </div> : ""}
                            {this.state.tab == "pubs" ? this.state.pubs ? this.state.pubs.length ?
                                <div className='new-pagination'>
                                    <button disabled={this.state.offsetpub === 0} onClick={() => this.setState({ offsetpub: this.state.offsetpub - 10 })} className='prev'>{this.state.offsetpub === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetpub ? (this.state.offsetpub / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.pubscount ? Math.ceil(this.state.pubscount / 10) : 1}</div> <button disabled={!this.state.pubnext} onClick={() => this.setState({ offsetpub: this.state.offsetpub + 10 })} className='next'>{this.state.pubnext ? <img src={pageright} /> : <img src={pagenoright} />}</button>
                                </div>
                                : "" : '' : ""}
                            {this.state.tab == "events" ? this.state.events ? this.state.events.length ? <div className='new-pagination'>
                                <button disabled={this.state.offsetevent === 0} onClick={() => this.setState({ offsetevent: this.state.offsetevent - 10 })} className='prev'>{this.state.offsetevent === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetevent ? (this.state.offsetevent / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.eventcount ? Math.ceil(this.state.eventcount / 10) : 1}</div> <button disabled={!this.state.eventnext} onClick={() => this.setState({ offsetevent: this.state.offsetevent + 10 })} className='next'>{this.state.eventnext ? <img src={pageright} /> : <img src={pagenoright} />}</button>
                            </div> : "" : '' : ""}
                        </div>
                    </div>
                        : <List />}
                </div>
                <NewFooter />
            </div >
        )
    }
}
export default ResearchCenter;